import { useAddToCart } from '@/features/cart/hooks/use-add-to-cart'
import { useProductDetailV2State } from '@/features/products/contexts/product-detail'
import { Box, Button, CircularProgress, Stack } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/navigation'
import React, { useState } from 'react'

type Props = {
  onClickShow?: () => void
}

export default function ButtonControlCartFixed({ onClickShow }: Props) {
  const t = useTranslations()
  const [isLoadingBuyNow, setIsLoadingBuyNow] = useState(false)
  const { handleAddToCart } = useAddToCart()
  const { productAddToCart, quantity } = useProductDetailV2State()
  const router = useRouter()
  const handleSubmit = async () => {
    setIsLoadingBuyNow(true)
    try {
      await handleAddToCart({
        productSelected: productAddToCart,
        quantity: quantity,
        callbackOnSuccess: () => {
          router.push('/cart')
        },
      })
    } catch (error) {
      console.log('Error in Buy Now:', error)
    } finally {
      setIsLoadingBuyNow(false)
    }
  }
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        width: '100%',
        zIndex: 100,
        bgcolor: 'background.paper',
        boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
        display: {
          xs: 'block',
          xl: 'none',
        },
      }}
    >
      <Stack direction={'row'} flex={1}>
        <Button
          variant="outlined"
          fullWidth
          onClick={onClickShow}
          sx={{
            fontWeight: 600,
            borderRadius: '0',
            fontSize: '0.9rem',
            p: ' 14px 8px',
          }}
        >
          {t('Thêm vào giỏ hàng')}
        </Button>
        <Button
          variant="contained"
          fullWidth
          loading={isLoadingBuyNow}
          onClick={handleSubmit}
          loadingIndicator={
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <CircularProgress size={16} sx={{ mr: 1, color: 'primary.contrastText' }} />
            </Box>
          }
          sx={{
            borderRadius: '0',
            color: 'primary.contrastText',
            fontWeight: 600,
            fontSize: '0.9rem',
            p: '14px 8px',
          }}
        >
          {t('Thanh toán ngay')}
        </Button>
      </Stack>
    </Box>
  )
}
